import { createAction, props } from "@ngrx/store";
import { StartAPensionFormModel } from "src/app/model/start-a-pension-form.model";

export const ResetComponentStateAction = createAction('[Start a pension update submitted component] reset component state')

export const SaveApplicationDataForUpdateSubmittedAction = createAction("[Start a pension update submitted component] set application data", props<{ model: StartAPensionFormModel }>());